module.exports = __webpack_public_path__ + "static/media/CosmoName.40b22c3b.png";